module.exports = __webpack_public_path__ + "static/img/swisshotelcompetence-logo.686f668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/swisshotelcompetence-logo.svg
// module id = LGw7
// module chunks = 0